"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTracking = exports.TrackingContext = exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tracking_1 = __importDefault(require("./tracking"));
const types_1 = require("./types");
__exportStar(require("./types"), exports);
var Tag_1 = require("./Tag");
Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return __importDefault(Tag_1).default; } });
exports.TrackingContext = (0, react_1.createContext)(tracking_1.default);
const useTracking = () => {
    const trk = (0, react_1.useContext)(exports.TrackingContext);
    const simplifiedTracking = (0, react_1.useMemo)(() => ({
        getMixpanelInstance: trk.getMixpanelInstance.bind(trk),
        people: trk.people,
        register: trk.register.bind(trk),
        track: trk.track.bind(trk),
        setMandatoryRegisters: trk.setMandatoryRegisters.bind(trk),
        unregister: trk.unregister.bind(trk),
    }), []);
    return simplifiedTracking;
};
exports.useTracking = useTracking;
function Tracking({ children, config, member, optedIn, displayInterface = types_1.Interface.WEBSITE, trackInterfaceChange, }) {
    if (!tracking_1.default.initialized)
        tracking_1.default.init(config, displayInterface);
    const memberId = member === null || member === void 0 ? void 0 : member.memberId;
    const [storedMemberId, setStoredMemberId] = (0, react_1.useState)(memberId);
    (0, react_1.useEffect)(() => {
        if (trackInterfaceChange)
            tracking_1.default.register({ Interface: displayInterface });
    }, [displayInterface, trackInterfaceChange]);
    (0, react_1.useEffect)(() => {
        if (optedIn) {
            tracking_1.default.optIn();
        }
        else {
            tracking_1.default.optOut();
        }
    }, [optedIn]);
    (0, react_1.useEffect)(() => {
        setStoredMemberId(memberId);
        if (!tracking_1.default.hasUser && member) {
            tracking_1.default.handleMember(member);
        }
    }, [memberId]);
    (0, react_1.useEffect)(() => {
        if (tracking_1.default.hasUser && member && storedMemberId !== memberId) {
            tracking_1.default.handleMember(member);
            console.debug('[Mixpanel] switching user');
        }
    }, [memberId, storedMemberId]);
    return (0, jsx_runtime_1.jsx)(exports.TrackingContext.Provider, { value: tracking_1.default, children: children });
}
exports.default = Tracking;
